import Button, { ButtonProps as CoreButtonProps } from "@material-ui/core/Button";
import { styled, Theme } from "@material-ui/core";

// sizes
export const JUMBO = "jumbo";
export const SMALl = "small";

// variants
export const FANCY = "fancy";
export const INVISIBLE = "invisible";
export const YELLOW = "yellow";
export const GREEN = "green";
export const GREEN_AND_LIGHT_GREEN = "green_and_light_green";

// default
export const DEFAULT = "default";

type Variant =
  | typeof FANCY
  | typeof INVISIBLE
  | typeof YELLOW
  | typeof DEFAULT
  | typeof GREEN
  | typeof GREEN_AND_LIGHT_GREEN;
type Dimension = typeof JUMBO | typeof SMALl;

interface ButtonProps extends CoreButtonProps {
  version?: Variant;
  dimension?: Dimension;
}

const buttonSizes = (theme: Theme, dimension?: Dimension) => {
  switch (dimension) {
    case JUMBO:
      return {
        height: theme.spacing(7),
      };
    case SMALl:
      return {
        height: theme.spacing(5),
      };
    default:
      return {
        height: theme.spacing(6),
      };
  }
};

const buttonVariant = (theme: Theme, variant?: Variant) => {
  switch (variant) {
    case FANCY:
      return {
        background: "linear-gradient(90deg, #F64F6E 0%, #FF8787 100%)",
        color: "white",
        "&:hover": {
          boxShadow: "0px 4px 4px rgba(27, 27, 27, 0.1)",
        },
        fontWeight: 500,
      };
    case YELLOW:
      return {
        backgroundColor: theme.palette.yellow200,
        color: theme.palette.secondary.main,
        "&:hover": {
          backgroundColor: theme.palette.yellow200,
        },
      };
    case GREEN:
      return {
        backgroundColor: theme.palette.secondary.main,
        color: "white",
        "&:hover": {
          backgroundColor: theme.palette.secondary.main,
          boxShadow: "0px 4px 4px rgba(27, 27, 27, 0.1)",
        },
      };

    case GREEN_AND_LIGHT_GREEN:
      return {
        color: theme.palette.green,
        backgroundColor: theme.palette.secondary.main,
        "&:hover": {
          backgroundColor: theme.palette.secondary.main,
          boxShadow: "0px 4px 4px rgba(27, 27, 27, 0.1)",
        },
      };
    case INVISIBLE:
      return {
        color: theme.palette.secondary.main,
        backgroundColor: "transparent",
        "&:hover": {
          color: theme.palette.turquoise.main,
          backgroundColor: "transparent",
          boxShadow: "unset",
        },
      };
    default:
      return {};
  }
};

export default styled(Button)<Theme, ButtonProps>(({ theme, version, dimension }) => {
  const sizeProps = buttonSizes(theme, dimension);
  const variantProps = buttonVariant(theme, version);
  return {
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      boxShadow: "0px 4px 4px rgba(27, 27, 27, 0.1)",
    },
    "&:active": {
      boxShadow: "0px 2px 2px rgba(27, 27, 27, 0.1)",
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.text.greyHome,
      background: "None",
      color: theme.palette.text.noResult,
    },
    "&.Mui-label": {
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: "150%",
    },
    whiteSpace: "nowrap",
    padding: `${theme.spacing(1)}px  ${theme.spacing(3)}px`,
    ...sizeProps,
    ...variantProps,
  };
});
